/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Type_LabelInputs */

const en_us2_bodymap_type_label = /** @type {(inputs: Bodymap_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was it?`)
};

const pt_br2_bodymap_type_label = /** @type {(inputs: Bodymap_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que foi?`)
};

const es_419_bodymap_type_label = /** @type {(inputs: Bodymap_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué fue?`)
};

const pt_pt2_bodymap_type_label = /** @type {(inputs: Bodymap_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que foi?`)
};

const fr_fr2_bodymap_type_label = /** @type {(inputs: Bodymap_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'était quoi ?`)
};

const de_de2_bodymap_type_label = /** @type {(inputs: Bodymap_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was war es?`)
};

const it_it2_bodymap_type_label = /** @type {(inputs: Bodymap_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che cosa è stato?`)
};

/**
* | output |
* | --- |
* | "What was it?" |
*
* @param {Bodymap_Type_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_type_label = /** @type {((inputs?: Bodymap_Type_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Type_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_type_label(inputs)
	if (locale === "es-419") return es_419_bodymap_type_label(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_type_label(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_type_label(inputs)
	if (locale === "de-DE") return de_de2_bodymap_type_label(inputs)
	if (locale === "it-IT") return it_it2_bodymap_type_label(inputs)
	return en_us2_bodymap_type_label(inputs)
});
export { bodymap_type_label as "bodymap.type.label" }